import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/desktop-optimizations.css';
import './styles/cmr-document-header-fix.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyColorsToRoot } from './utils/colors.js';
import { applyBrowserOptimizations, isChrome } from './utils/browserDetection.js';
import { initializeChromeCMRFixes } from './utils/chromeCMRFix.js';
import { installTenantFetchInterceptor } from './api/request.js';
import { LanguageProvider } from './i18n/LanguageContext.jsx';

installTenantFetchInterceptor();
applyColorsToRoot();
applyBrowserOptimizations();
try {
  document.documentElement.classList.toggle(
    'sidebar-collapsed',
    localStorage.getItem('sidebarCollapsed') === 'true'
  );
} catch {
  // Safari can deny storage (for example in restricted/private contexts).
  // The default sidebar state remains usable when persistence is unavailable.
  document.documentElement.classList.add('sidebar-collapsed');
}

const renderApp = () => {
  initializeChromeCMRFixes();
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </React.StrictMode>
  );
};

if (isChrome()) {
  // Keep legacy Chrome workarounds out of Safari. CSS feature queries cannot
  // reliably distinguish the two WebKit-derived engines.
  Promise.all([
    import('./styles/chrome-optimizations.css'),
    import('./styles/chrome-cmr-document-fix.css'),
    import('./styles/chrome-cmr-header-override.css'),
    import('./styles/chrome-fixed-override.css'),
    import('./styles/chrome-parent-fix.css'),
  ]).then(renderApp, renderApp);
} else {
  renderApp();
}

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
